// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { Kpi } from '../../../overblik/model';
import { Spinner } from '../../Spinner';
import { Panel } from '../Panel';
import styles from './Overblik.module.css';

export interface KpiPanelProps {
  /** `panelKpis(summary)`; null while the summary loads. */
  kpis: readonly Kpi[] | null;
}

/**
 * "Nøgletal" (v8 `.kpi`): the case's figures in a two-column grid, label
 * over figure. The figure turns warn/crit where it asks for action. The case
 * record itself is the "Sagen" panel below it (SagenPanel).
 */
export function KpiPanel({ kpis }: KpiPanelProps) {
  return (
    <Panel title="Nøgletal">
      {kpis ? (
        <dl className={styles.kpis}>
          {kpis.map((k) => (
            <div key={k.key} className={styles.kpi}>
              <dt className={styles.kpiLabel}>{k.label}</dt>
              <dd className={k.ink ? `${styles.kpiValue} ${styles[k.ink]}` : styles.kpiValue}>
                {k.value}
                {k.unit && <small className={styles.unit}> {k.unit}</small>}
              </dd>
              {k.hint && <dd className={styles.kpiHint}>{k.hint}</dd>}
            </div>
          ))}
        </dl>
      ) : (
        <Spinner label="Indlæser nøgletal…" />
      )}
    </Panel>
  );
}
